import type { UseMutationOptions } from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';

import { generateDocument } from './gateway-document-api';

export const useGenerateDocumentMutation = (
  options?: UseMutationOptions<Blob, Error, string>
) => {
  return useMutation({
    mutationKey: ['generate-document'],
    mutationFn: (applicationId: string) => generateDocument(applicationId),
    ...options,
  });
};
